/**
 * Created by sumudu on 12/5/16.
 */
'use strict';

(function () {
    angular
        .module('crewSchedule')
        .service('crewSchAssignTraningModel', crewSchAssignTraningModel);

    function crewSchAssignTraningModel (rx,RemoteService) {
        var self = this;

        /**
         * Expose Observables
         * @type {rx.Subject}
         */
        self.trainingsForCrew = new rx.Subject();
        self.crewInfo = new rx.ReplaySubject();

        /**
         * Update trainings for selected crew stream
         * @param trainings
         */
        self.setTrainingsForCrew = function (trainings) {
            self.trainingsForCrew.onNext(trainings);
        };

        self.setCrewInfo = function (crew) {
            self.crewInfo.onNext(crew);
        };
    }
})();